module.exports = __webpack_public_path__ + "static/media/49-iveco.55336690.jpg";